import { injectStyle } from "./../../../utils/style";
import { h } from "./../../../utils/createElement";
import { __assign, __extends } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import KeyCode from './util/KeyCode';
import DateTable from './date/DateTable';
import CalendarHeader from './calendar/CalendarHeader';
import CalendarFooter from './calendar/CalendarFooter';
import { calendarMixinWrapper, calendarMixinPropTypes, calendarMixinDefaultProps, getNowByCurrentStateValue, } from './mixin/CalendarMixin';
import { commonMixinWrapper, propType, defaultProp } from './mixin/CommonMixin';
import DateInput from './date/DateInput';
import { getTimeConfig, getTodayTime, syncTime } from './util';
import { goStartMonth, goEndMonth, goTime } from './util/toTime';
import zhCN from './locale/zh_CN';
import dayjs from './dayjs';
injectStyle("components/DatePicker/rc-calendar/style/index/Calendar.css", "[data-dui-0-122-5~=\"dui-calendar\"]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}[data-dui-0-122-5~=\"dui-calendar\"],[data-dui-0-122-5~=\"dui-calendar\"] *{-webkit-box-sizing:border-box;box-sizing:border-box}[data-dui-0-122-5~=\"dui-calendar\"] span[role=button]{cursor:pointer;outline:none}[data-dui-0-122-5~=\"dui-calendar-date-panel\"],[data-dui-0-122-5~=\"dui-calendar-panel\"]{position:relative;outline:none}[data-dui-0-122-5~=\"dui-calendar-cell\"]{padding:1px 0;font-size:14px;font-weight:500;color:var(--text-ultrastrong,rgba(0,0,0,.88))}[data-dui-0-122-5~=\"dui-calendar-week-number-cell\"]{text-align:center}[data-dui-0-122-5~=\"dui-calendar-body\"]{padding:13px 6px}[data-dui-0-122-5~=\"dui-calendar-hidden\"]{display:none}[data-dui-0-122-5~=\"dui-calendar-next-month-btn\"],[data-dui-0-122-5~=\"dui-calendar-next-year-btn\"],[data-dui-0-122-5~=\"dui-calendar-prev-month-btn\"],[data-dui-0-122-5~=\"dui-calendar-prev-year-btn\"]{position:absolute;top:0;display:inline-block;padding:0 5px;margin:9px 0;color:#999;line-height:34px}[data-dui-0-122-5~=\"dui-calendar-next-month-btn\"]:hover,[data-dui-0-122-5~=\"dui-calendar-next-year-btn\"]:hover,[data-dui-0-122-5~=\"dui-calendar-prev-month-btn\"]:hover,[data-dui-0-122-5~=\"dui-calendar-prev-year-btn\"]:hover{background-color:#e9ebed}[data-dui-0-122-5~=\"dui-calendar-next-year-btn\"]{right:13px}[data-dui-0-122-5~=\"dui-calendar-next-year-btn\"],[data-dui-0-122-5~=\"dui-calendar-prev-year-btn\"]{width:16px;height:16px;background:url(../img/arrow_double@2x.png) no-repeat 50%/contain}[data-dui-0-122-5~=\"dui-calendar-prev-year-btn\"]{left:13px;-webkit-transform:rotate(180deg);transform:rotate(180deg)}[data-dui-0-122-5~=\"dui-calendar-time-picker-wrap\"]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;padding:8px 24px;border-top:1px solid #ebebeb}[data-dui-0-122-5~=\"dui-calendar-time-picker-title\"]{-webkit-box-flex:0;-webkit-flex:none;-ms-flex:none;flex:none;margin-right:62px;font-size:14px}[data-dui-0-122-5~=\"dui-calendar-time-picker-component\"]{-webkit-box-flex:1;-webkit-flex:1;-ms-flex:1;flex:1}");
var getDayjsObjectIfValid = function (date) { return ((date === null || date === void 0 ? void 0 : date.isValid()) ? date : false); };
var Calendar = (function (_super) {
    __extends(Calendar, _super);
    function Calendar(props) {
        var _this = _super.call(this, props) || this;
        _this.onPanelChange = function (value, mode) {
            var _a = _this, props = _a.props, state = _a.state;
            if (!props.mode) {
                _this.setState({ mode: mode });
            }
            props.onPanelChange(value || state.value, mode);
        };
        _this.onKeyDown = function (event) {
            if (event.target.nodeName.toLowerCase() === 'input') {
                return undefined;
            }
            var keyCode = event.keyCode;
            var ctrlKey = event.ctrlKey || event.metaKey;
            var _a = _this.props, disabledDate = _a.disabledDate, onKeyDown = _a.onKeyDown;
            var value = _this.state.value;
            switch (keyCode) {
                case KeyCode.DOWN:
                    _this.goTime(1, 'weeks');
                    event.preventDefault();
                    return 1;
                case KeyCode.UP:
                    _this.goTime(-1, 'weeks');
                    event.preventDefault();
                    return 1;
                case KeyCode.LEFT:
                    _this.goTime(-1, ctrlKey ? 'years' : 'days');
                    event.preventDefault();
                    return 1;
                case KeyCode.RIGHT:
                    _this.goTime(1, ctrlKey ? 'years' : 'days');
                    event.preventDefault();
                    return 1;
                case KeyCode.HOME:
                    _this.setValue(goStartMonth(value));
                    event.preventDefault();
                    return 1;
                case KeyCode.END:
                    _this.setValue(goEndMonth(value));
                    event.preventDefault();
                    return 1;
                case KeyCode.PAGE_DOWN:
                    _this.goTime(1, 'month');
                    event.preventDefault();
                    return 1;
                case KeyCode.PAGE_UP:
                    _this.goTime(-1, 'month');
                    event.preventDefault();
                    return 1;
                case KeyCode.ENTER:
                    if (!disabledDate || !disabledDate(value)) {
                        _this.onSelect(value, {
                            source: 'keyboard',
                        });
                    }
                    event.preventDefault();
                    return 1;
                default:
                    onKeyDown(event);
                    return 1;
            }
        };
        _this.onClear = function () {
            var onClear = _this.props.onClear;
            _this.onSelect(null);
            onClear();
        };
        _this.onOk = function () {
            var selectedValue = _this.state.selectedValue;
            var onOk = _this.props.onOk;
            onOk(selectedValue);
        };
        _this.onDateInputChange = function (value) {
            _this.onSelect(value, {
                source: 'dateInput',
            });
        };
        _this.onDateInputSelect = function (value) {
            _this.onSelect(value, {
                source: 'dateInputSelect',
            });
        };
        _this.onDateTableSelect = function (value) {
            var timePicker = _this.props.timePicker;
            var selectedValue = _this.state.selectedValue;
            if (!selectedValue && timePicker) {
                var timePickerDefaultValue = timePicker.props.defaultValue;
                if (timePickerDefaultValue) {
                    syncTime(timePickerDefaultValue, value);
                }
            }
            _this.onSelect(value);
        };
        _this.onToday = function () {
            var value = _this.state.value;
            var now = getTodayTime(value);
            _this.onSelect(now, {
                source: 'todayButton',
            });
        };
        _this.onBlur = function (event) {
            setTimeout(function () {
                var dateInput = DateInput.getInstance();
                var rootInstance = _this.rootInstance;
                var timePicker = _this.props.timePicker;
                if (!rootInstance
                    || rootInstance.contains(document.activeElement)
                    || (dateInput === null || dateInput === void 0 ? void 0 : dateInput.contains(document.activeElement))
                    || timePicker) {
                    return;
                }
                var onBlur = _this.props.onBlur;
                onBlur(event);
            }, 0);
        };
        var value = getDayjsObjectIfValid(props.value)
            || getDayjsObjectIfValid(props.defaultValue)
            || dayjs();
        _this.state = {
            mode: props.mode || 'date',
            value: value,
            selectedValue: props.selectedValue || props.defaultSelectedValue || value,
        };
        return _this;
    }
    Calendar.getDerivedStateFromProps = function (nextProps, state) {
        var value = nextProps.value, selectedValue = nextProps.selectedValue;
        var newState = {};
        if (nextProps.mode && state.mode !== nextProps.mode) {
            newState.mode = nextProps.mode;
        }
        if (nextProps.value) {
            newState.value = getDayjsObjectIfValid(value)
                || getDayjsObjectIfValid(nextProps.defaultValue)
                || getNowByCurrentStateValue(state.value);
        }
        if (nextProps.selectedValue) {
            newState.selectedValue = selectedValue;
        }
        return newState;
    };
    Calendar.prototype.componentDidMount = function () {
        var showDateInput = this.props.showDateInput;
        if (showDateInput) {
            this.saveFocusElement(DateInput.getInstance());
        }
    };
    Calendar.prototype.goTime = function (direction, unit) {
        var value = this.state.value;
        this.setValue(goTime(value, direction, unit));
    };
    Calendar.prototype.renderDateInput = function () {
        var _a = this.props, showDateInput = _a.showDateInput, prefixCls = _a.prefixCls, inputMode = _a.inputMode, locale = _a.locale, dateInputPlaceholder = _a.dateInputPlaceholder, clearIcon = _a.clearIcon, disabledTime = _a.disabledTime, disabledDate = _a.disabledDate;
        var _b = this.state, value = _b.value, selectedValue = _b.selectedValue;
        return showDateInput ? (h(DateInput, { key: "date-input", showClear: true, clearIcon: clearIcon, disabledDate: disabledDate, disabledTime: disabledTime, format: this.getFormat(), inputMode: inputMode, locale: locale, placeholder: dateInputPlaceholder, prefixCls: prefixCls, selectedValue: selectedValue, value: value, onChange: this.onDateInputChange, onClear: this.onClear, onSelect: this.onDateInputSelect })) : null;
    };
    Calendar.prototype.renderCalendarHeader = function () {
        var _a = this.props, prefixCls = _a.prefixCls, locale = _a.locale, disabledDate = _a.disabledDate, renderFooter = _a.renderFooter, monthCellRender = _a.monthCellRender, monthCellContentRender = _a.monthCellContentRender;
        var _b = this.state, mode = _b.mode, value = _b.value;
        return (h(CalendarHeader, { disabledMonth: disabledDate, locale: locale, mode: mode, monthCellContentRender: monthCellContentRender, monthCellRender: monthCellRender, prefixCls: prefixCls, renderFooter: renderFooter, value: value, onPanelChange: this.onPanelChange, onValueChange: this.setValue }));
    };
    Calendar.prototype.renderDateTable = function () {
        var _a = this.props, locale = _a.locale, prefixCls = _a.prefixCls, dateRender = _a.dateRender, disabledDate = _a.disabledDate, showWeekNumber = _a.showWeekNumber;
        var _b = this.state, value = _b.value, selectedValue = _b.selectedValue;
        return (h(DateTable, { dateRender: dateRender, disabledDate: disabledDate, locale: locale, prefixCls: prefixCls, selectedValue: selectedValue, showWeekNumber: showWeekNumber, value: value, onSelect: this.onDateTableSelect }));
    };
    Calendar.prototype.renderCalendarFooter = function () {
        var _a = this.props, showToday = _a.showToday, showOk = _a.showOk, locale = _a.locale, prefixCls = _a.prefixCls, renderFooter = _a.renderFooter, disabledTime = _a.disabledTime, disabledDate = _a.disabledDate, timePicker = _a.timePicker;
        var _b = this.state, mode = _b.mode, selectedValue = _b.selectedValue, value = _b.value;
        return (h(CalendarFooter, { disabledDate: disabledDate, disabledTime: disabledTime, locale: locale, mode: mode, okDisabled: showOk !== false && (!selectedValue || !this.isAllowedDate(selectedValue)), prefixCls: prefixCls, renderFooter: renderFooter, selectedValue: selectedValue, showOk: showOk, showToday: showToday, timePicker: timePicker, value: value, onOk: this.onOk, onSelect: this.onSelect, onToday: this.onToday }));
    };
    Calendar.prototype.renderTimePicker = function () {
        var _a = this.props, timePicker = _a.timePicker, disabledTime = _a.disabledTime, prefixCls = _a.prefixCls, locale = _a.locale;
        var selectedValue = this.state.selectedValue;
        var disabledTimeConfig = disabledTime ? getTimeConfig(selectedValue, disabledTime) : null;
        var timePickerProps = __assign(__assign(__assign({}, timePicker.props), disabledTimeConfig), { onChange: this.onDateInputChange, value: selectedValue, disabledTime: disabledTime });
        if (timePicker.props.defaultValue !== undefined) {
            timePickerProps.defaultOpenValue = timePicker.props.defaultValue;
        }
        var timePickerEle = React.cloneElement(timePicker, timePickerProps);
        return (h("div", { className: prefixCls + "-time-picker-wrap" },
            h("div", { className: prefixCls + "-time-picker-title" }, locale.time),
            h("div", { className: prefixCls + "-time-picker-component" }, timePickerEle)));
    };
    Calendar.prototype.renderPanelElement = function () {
        var _a = this.props, prefixCls = _a.prefixCls, focusablePanel = _a.focusablePanel, timePicker = _a.timePicker;
        var wrapperProps = {
            tabIndex: focusablePanel ? 0 : undefined,
        };
        return (h("div", { key: "panel", className: prefixCls + "-panel" },
            this.renderDateInput(),
            h("div", __assign({}, wrapperProps, { className: prefixCls + "-date-panel" }),
                this.renderCalendarHeader(),
                h("div", { className: prefixCls + "-body" }, this.renderDateTable()),
                timePicker ? this.renderTimePicker() : null,
                this.renderCalendarFooter())));
    };
    Calendar.prototype.render = function () {
        var _a = this.props, prefixCls = _a.prefixCls, renderSidebar = _a.renderSidebar, showWeekNumber = _a.showWeekNumber;
        var children = [];
        if (renderSidebar) {
            children.push(renderSidebar());
        }
        var panelElement = this.renderPanelElement();
        children.push(panelElement);
        return this.renderRoot({
            children: children,
            className: showWeekNumber ? prefixCls + "-week-number" : '',
        });
    };
    return Calendar;
}(React.Component));
Calendar.propTypes = __assign(__assign(__assign({}, calendarMixinPropTypes), propType), { className: PropTypes.string, clearIcon: PropTypes.node, dateInputPlaceholder: PropTypes.string, dateRender: PropTypes.func, defaultSelectedValue: PropTypes.instanceOf(dayjs), defaultValue: PropTypes.instanceOf(dayjs), disabledDate: PropTypes.func, disabledTime: PropTypes.func, focusablePanel: PropTypes.bool, inputMode: PropTypes.string, locale: PropTypes.shape({}), mode: PropTypes.oneOf(['time', 'date', 'month', 'year', 'decade']), prefixCls: PropTypes.string, renderFooter: PropTypes.func, renderSidebar: PropTypes.func, selectedValue: PropTypes.instanceOf(dayjs), showDateInput: PropTypes.bool, showOk: PropTypes.bool, showToday: PropTypes.bool, showWeekNumber: PropTypes.bool, style: PropTypes.shape({}), timePicker: PropTypes.element, value: PropTypes.instanceOf(dayjs), onBlur: PropTypes.func, onChange: PropTypes.func, onClear: PropTypes.func, onKeyDown: PropTypes.func, onOk: PropTypes.func, onPanelChange: PropTypes.func, onSelect: PropTypes.func });
Calendar.defaultProps = __assign(__assign(__assign({}, calendarMixinDefaultProps), defaultProp), { locale: zhCN, onBlur: Function.prototype, onOk: Function.prototype, onPanelChange: Function.prototype, showDateInput: true, showToday: true, timePicker: null });
export default calendarMixinWrapper(commonMixinWrapper(Calendar));
